/**
 * Shared recruiter language filter (Interested Feed + Candidate Search).
 * Stored as { de: boolean; en: boolean } for manual search checkboxes.
 */
export const RECRUITER_LANG_FILTER_KEY = 'cevee_recruiter_lang_filter';

export type LangFilterTab = 'all' | 'de' | 'en';

export function readRecruiterLangFilterTab(): LangFilterTab {
  try {
    const raw = localStorage.getItem(RECRUITER_LANG_FILTER_KEY);
    if (!raw) return 'all';
    const o = JSON.parse(raw) as { de?: boolean; en?: boolean };
    if (typeof o.de === 'boolean' && typeof o.en === 'boolean') {
      if (o.de && o.en) return 'all';
      if (o.de && !o.en) return 'de';
      if (!o.de && o.en) return 'en';
    }
  } catch {
    /* ignore */
  }
  return 'all';
}

export function persistRecruiterLangFilterTab(v: LangFilterTab) {
  const payload =
    v === 'all' ? { de: true, en: true } : v === 'de' ? { de: true, en: false } : { de: false, en: true };
  try {
    localStorage.setItem(RECRUITER_LANG_FILTER_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}
